module.exports = __webpack_public_path__ + "img/2-4.2b0b9e54.svg";